import { Injectable } from '@angular/core';
import {
  PushNotifications,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
} from '@capacitor/push-notifications';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UtilityService } from '../helper/utility.service';
import { VisoPushNotification } from '@viso/core/models';
import { UserService } from '@viso/core/data-access';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  constructor(
    private utility: UtilityService,
    private userService: UserService
  ) {}

  private $registrationToken = new BehaviorSubject<PushNotificationToken>(null);
  private $pushNotificationReceived = new BehaviorSubject<PushNotification>(
    null
  );
  private $pushNotificationActionPerformed = new BehaviorSubject<PushNotificationActionPerformed>(
    null
  );

  public startRegistration() {
    this.registerPush();
  }

  reEmitRegisterationToken() {
    const currentValue = this.$registrationToken.getValue();
    this.$registrationToken.next(currentValue);
  }

  private registerPush() {
    PushNotifications.requestPermissions().then((permission) => {
      if (permission.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // No permission for push granted
      }
    });

    PushNotifications.addListener(
      'registration',
      async (token: PushNotificationToken) => {
        this.$registrationToken.next(token);
      }
    );

    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Error: ' + JSON.stringify(error));
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotification) => {
        this.$pushNotificationReceived.next(notification);
      }
    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (notification: PushNotificationActionPerformed) => {
        setTimeout(() => {
          this.$pushNotificationActionPerformed.next(notification);
        });

        const data: VisoPushNotification = {
          props: {
            data: JSON.parse(notification.notification.data.data),
            notification: JSON.parse(notification.notification.data.notification)
          }
        };

        const user = await this.userService.getUser().toPromise();
        data['user_type'] = user['user_type'];
        this.utility.notificationRedirect(data, true);
      }
    );
  }

  getFcmRegistrationToken() {
    return this.$registrationToken.asObservable();
  }

  getReceivedPushNotification() {
    return this.$pushNotificationReceived.asObservable();
  }

  getActionPerformedPushNotification() {
    return this.$pushNotificationActionPerformed.asObservable().pipe(
      filter(i => !!i)
    );
  }
}
